import { useEffect } from 'react'

/**
 * Hook to dynamically update the document (browser tab) title
 * @param title - The title to display
 */
export const useDocumentTitle = (title: string) => {
  useEffect(() => {
    const originalTitle = document.title
    document.title = title
    return () => {
      document.title = originalTitle
    }
  }, [title])
}
export default useDocumentTitle
